import React from "react";
import Style from "./OtpScreen.module.scss";
import { useEffect } from "react";

const OtpScreen = ({
  OtpInput,
  otp,
  setOTP,
  SetOTPCompleted,
  isOtpOpen,
  emailInput,
  setEmailCheckPassed,
  editEmail,
  userEmail,
  otpInvalid,
  statusOTPcall,
  otpSubmitButton,
  otpCounter,
  setOtpCounter,
  forgotPasswordHandler,
  formatTime,
}) => {
  const handleResendOtp = () => {
    let data = {
      email: userEmail,
    };
    forgotPasswordHandler(data, {});
  };
  return (
    <>
      <div className={`${Style.ForgotPassword__form}`}>
        {/* Email */}
        <div className="form-group">
          <div className="d-flex justify-content-between pb-2">
            <label
              htmlFor="input_email"
              className={`${isOtpOpen ? Style.otp_open : ""}`}
            >
              Email address
            </label>
            {isOtpOpen && (
              <button
                className="btn btn-link"
                onClick={() => {
                  editEmail();
                  setEmailCheckPassed(false);
                }}
              >
                Change?
              </button>
            )}
          </div>
          <div className="input-holder">
            <input
              type="email"
              name="input_email"
              id="input_email"
              className="form-control"
              placeholder="Enter Your Email Id"
              autoComplete="new-email"
              disabled={true}
              ref={emailInput}
              value={userEmail}
            />
          </div>
          {/* <small>Please enter valid Email ID</small> */}
        </div>
      </div>

      <div className="form-group otp-inputs text-center">
        <span htmlFor="input_otp">OTP Send to Email</span>
        <div className={`input-holder pt-2 ${Style.otp_input_center_item}`}>
          <OtpInput
            value={otp}
            numInputs={4}
            shouldAutoFocus={true}
            inputType="number"
            onChange={(value) => {
              /*****************************************
               * CHECKING INPUT VALUE IS NUMBER OR NOT. IF INPUT IS A NUMBER THEN SAVES THE VALUE OTHERWISE DISCARD *
               *****************************************/
              if (/^-?\d+$/.test(value) || value === "") {
                setOTP(value);
              }
            }}
            renderInput={(props) => (
              <input
                {...props}
                className={`${otpInvalid == true ? Style.input_Style_error : ""}`}
              />
            )}
          />

          {/* <button
            type="submit"
            className={`${Style.Submit_Btn} btn btn-primary w-100 mb-4`}
            onClick={otpSubmitButton}
            disabled={!otpInvalid}
          >
            Submit
          </button> */}
          <div className={Style.Auth__option}>
            <span>Didn't Receive the OTP? </span>
            {otpCounter > 0 ? (
              <span className={Style.Auth__option_timer}>
                {formatTime(otpCounter)}
              </span>
            ) : (
              ""
            )}
            {otpCounter == 0 ? (
              <button
                className="btn btn-link link-primary"
                onClick={() => {
                  // resendCallback();
                  // setOtpCounter(30);
                  handleResendOtp();
                }}
              >
                Resend OTP
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpScreen;
